<template>
	<div v-show="showBronnen">
			<p><small>Het paarse bolletje hieronder is jouw wijk. De balkjes geven weer hoeveel procent van de inwoners bijvoorbeeld voldoet aan de beweegrichtlijn of overgewicht heeft. Zo kun je de gezondheid in jouw wijk vergelijken met je gemeente en de rest van Nederland.</small></p>

			<div class='knd-chart__legend m-t-md'>
				<ul class='knd-chart__legend_list'>
					<li class='legend__label legend__buurt'>Je wijk</li>
					<li class='legend__label legend__gemeente'>Je gemeente</li>
					<li class='legend__label legend__nederland'>Nederland</li>
				</ul>
			</div>

			<div class='knd-charts m-t-md' ref='charts'></div>

		<div class='knd-source knd-text-sm m-t-md' >
				Bron: Gezondheidsmonitor 2020, RIVM | Kerncijfers wijken en buurten 2019, CBS en Vektis via <a href='https://www.waarstaatjegemeente.nl/jive?workspace_guid=1de1eabb-80bd-4cdc-9019-d0b7b67130bd' target="_blank">waarstaatjegemeente.nl</a>.
		</div>

	</div>
</template>

<script>
	import BeeswarmChart from './beeswarm';

	import * as d3 from 'd3';

	export default {
		name: 'Buurtinfo',
		computed: {
			buurtCode() {
				return this.$store.state.buurtCode;
			}
		},
		data:function() {
			return {
				showBronnen: false
			}
		},
		watch: {
			buurtCode: {
				immediate: true,
				deep: true,
				handler: function (newVal, oldVal) {
					if(!newVal) return;
					this.renderCharts();
				}
			}
		},
		methods: {
			renderCharts() {
				this.showBronnen = true;
				let el = this.$refs.charts;
				el.innerHTML = '';
				let data = this.$store.getters.buurtInfo;

				this.renderChart(data, {
					label: "Overgewicht",
					el,
					key: 'overgewicht'
				});

				this.renderChart(data, {
					label: "Lage opleiding",
					el,
					ticks: 2,
					key: 'opleiding'
				});


				this.renderChart(data, {
					label: "% voelt zich gezond",
					el,
					key: 'ervaren_gezondheid_goed_zeer_goed'
				});

				this.renderChart(data, {
					label: "Voldoet aan beweegrichtlijn",
					el,
					key: 'voldoet_aan_beweegrichtlijn'
				});

				this.renderChart(data, {
					label: "Diabetes type 1 en 2",
					el,
					key: 'diabetes'
				});

			},

			renderChart(data, {
				el = document.body,
				label= 'in %',
				ticks = 2,
				key = 'prct_laag_opgeleid'
			}) {

				let arr = [];
				for (const property in data) {
					if(data[property] && data[property][key] && data[property][key] !== 'NA' )  {
						arr.push({
							label: property,
							value: +data[property][key] || null
						});
					}
				}

				let chart = BeeswarmChart(arr, {
					x: d => d.value,
					label: label,
					type: d3.scaleLinear, // try d3.scaleLog
					width: 200,
					height: 50,
					tickSize: 0,
					// xDomain: [0, 100],
					ticks: ticks,
					marginBottom: 15,
					title: d => d.label,
					radius: 5
				})		

				el.innerHTML += `<div class='knd-buurt__chart'><div class='label'>${label}</div> <div class='graphic'>${chart.outerHTML}</div></div>`;	
					// title: d => `${d.Origin}: ${d.Name}\n${d.Weight_in_lbs.toLocaleString("en")} lbs.`,
			}

		}
	}
</script>